import { AnalyticsEvent, fireGtmEvent } from '../../utils/analytics/index';

interface UpgradeContractRequestBaseContext {
  listingId: string;
  sbizClientId: string;
  contractStartDate: string;
}

export const upgradeContractRequest = {
  prompt: {
    viewed(context: UpgradeContractRequestBaseContext) {
      fireGtmEvent(AnalyticsEvent.UpgradeContractRequestViewed, context);
    },
  },
  upgrade: {
    clicked(context: UpgradeContractRequestBaseContext & { tier: string }) {
      fireGtmEvent(AnalyticsEvent.UpgradeContractRequested, context);
    },
  },
  confirmation: {
    viewed(context: UpgradeContractRequestBaseContext & { tier: string }) {
      fireGtmEvent(AnalyticsEvent.UpgradeContractRequestConfirmation, context);
    },
  },
};
